import { AttentionBanner, Button, fetchWithRetry, Modal } from '@flos/react-ui';
import { FunctionComponent, useEffect, useState } from 'react';
import { useResourceBundle } from '../contexts/ResourceContext';
import { useAppDispatch, useAppSelector } from '../hooks/useRedux';
import { navigationActions } from '../store/navigation.slice';

interface Props {
  /**
   * Path of the content block. E.g. 'shared/content-blocks/generel/selvbetjening/bestil-et-opkald/lukning-af-skader'
   */
  path: string;
}

const SectionClosed: FunctionComponent<Props> = ({ path }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const dispatch = useAppDispatch();
  const resource = useResourceBundle();

  const contentBlockHost = useAppSelector((state) => state.settings.endpointConfig.htmlContent);

  const [content, setContent] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    fetchContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- onload
  }, []);

  const fetchContent = () => {
    setError(false);
    fetchWithRetry(`${contentBlockHost}/`, {
      params: {
        documentPath: path,
        template: 'nowrapper',
      },
    })
      .then((resp) => {
        if (resp.ok) {
          return resp.text();
        } else {
          throw new Error(resp.statusText);
        }
      })
      .then((body) => {
        setContent(body);
      })
      .catch(() => setError(true));
  };

  const revertSelection = () => dispatch(navigationActions.selectCategory({ category: undefined }));

  return (
    <Modal isOpen={isOpen} onDismiss={revertSelection}>
      {!error ? (
        <div className="u-spacing-stack-l" dangerouslySetInnerHTML={{ __html: content }} />
      ) : (
        <AttentionBanner role="alert" className="u-spacing-stack-xl">
          <p>
            Der opstod en fejl. <br />
            <a
              onClick={(ev) => {
                ev.preventDefault();
                fetchContent();
              }}
              href="#fallback-ui"
              id="fallback-ui"
              className="Go"
              role="button"
            >
              Prøve igen
            </a>
          </p>
        </AttentionBanner>
      )}
      <Button
        variant="secondary"
        onClick={() => {
          setIsOpen(false);
          revertSelection();
        }}
      >
        {resource['label.section.button.close']}
      </Button>
    </Modal>
  );
};

export default SectionClosed;
